import { Button } from "antd";
import { Task, TaskState } from "gql/graphql";
import React from "react";

interface Props {
  tasks: Task[] | any,
  filter: string,
  handlerChange: any,
  phaseSelect: any
}

const ButtonTabsFilters = ({ tasks, phaseSelect, filter, handlerChange }: Props) => {
  
  /** se filtran las tareas con hidden igual a true
   *  esto aplica para la task add-docs que es donde se suben los additional documents y siempre esta oculta
   *  y para las tareas nuevas que se creen desde processing y que se eliminen despues.
  */
  const tasksFiltered = tasks.filter((task: any) => !task?.hidden)

  const getTotal = (state: string) => {
    if (state === 'ACTION_REQUIRED') {
      return tasksFiltered?.filter((item: any) =>
        item?.state === TaskState.ComingSoon || item?.state === TaskState.Draft || item?.state === TaskState.Incomplete ||
        item?.state === TaskState.RequestError)?.length || 0;
    }
    return tasksFiltered?.filter((item: any) => item?.state === state)?.length || 0;
  }

  const dummyTabsFilters = [
    { id: 1, name: "All", key: "all", amount: tasksFiltered?.length || 0 },
    { id: 2, name: "Action Required", key: "ACTION_REQUIRED", amount: getTotal('ACTION_REQUIRED') },
    { id: 3, name: "In Review", key: "REVIEW", amount: getTotal('REVIEW') },
    //+1 for Property Access Details
    { id: 4, name: "Approved", key: "APPROVED", amount: getTotal('APPROVED')},
  ];

  return (
    <section className="ButtonTabsFilters">
      {dummyTabsFilters?.map((tab) => (
        <Button
          onClick={() => handlerChange(tab.key)}
          className={`tab ${filter === tab.key && "tab-active"} ${tab.amount === 0 && "disabled"}`}
          key={tab.key}
          disabled={tab.amount === 0}>
          {tab.name} <span className="number">{tab.amount}</span>
        </Button>
      ))}
    </section>
  );
};
export default ButtonTabsFilters;
